import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { RmZoneAdapter } from './dto/rm-zone.adapter';
import { RmZonesController } from './rm-zones.controller';
import { RmZones } from './rm-zones.entity';
import { RmZonesService } from './rm-zones.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([RmZones]),
  ],
  controllers: [RmZonesController],
  providers: [RmZonesService,RmZoneAdapter,ApplicationExceptionHandler,RmZones,LogsService]
})
export class RMZonesModule {}
